import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ExpressionState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ExpressionQuery extends QueryEntity<ExpressionState> {

  constructor(protected store: Store) {
    super(store);
  }

}
